import styled from 'styled-components';
import { Upload } from 'antd';

export const LibUpload = styled(Upload)``;
